<main class="flex min-h-screen flex-col bg-(image:--bg-gradient-brand)">
  <header
    class="mx-auto flex w-full max-w-7xl items-center justify-center px-6 py-6 md:justify-start md:p-4 lg:px-8"
  >
    <img src="/logo-alt.svg" alt="" class="h-auto w-[120px] shrink-0 md:w-auto" />
  </header>
  <div
    class="mx-auto flex min-h-0 w-full max-w-7xl flex-1 flex-col justify-center overflow-y-auto px-6 pb-6 md:px-4 md:pb-8 lg:px-8"
  >
    <router-outlet />
  </div>
</main>
